import React, { useState } from 'react'
import { Formik } from 'formik'
import '../Payment/PaymentForm.scss'
import '../Customize/CustomizeForm.scss'
import Button from '../../../../../../components/button/Button'
import emailjs from 'emailjs-com'

import { paypalValidation } from '../Payment/validation'
import CheckboxComponent from './checkboxComponent'

import checkedIcon from '../../../../../../assets/checkedIcon.svg'
import uncheckedIcon from '../../../../../../assets/uncheckedIcon.svg'
import { useCountryContextContext } from '../../../../../../hooks/CountryContext'

const data = [
  { msg: 'After Hours and Overflow Support', state: false },
  { msg: 'Customer Service', state: false },
  { msg: 'Disaster Recovery', state: false },
  { msg: 'Enrollment', state: false },
  { msg: 'E-mail Processing', state: false },
  { msg: 'Inbound Sales', state: false },
  { msg: 'IVR', state: false },
  { msg: 'Lead Qualification', state: false },
  { msg: 'Live Chat', state: false },
  { msg: 'Outbound', state: false },
  { msg: 'Reservations', state: false },
  { msg: 'Technical Support', state: false },
]

const CustomizeForm = () => {
  const [checkBoxes, setCheckboxes] = useState(data)
  const [buttonState, setButtonState] = useState(false)
  const [radioOption, setRadioOption] = useState(2)
  const [resMsg, setResMsg] = useState({ msg: '', eleClass: '' })
  const [list1Radio, setList1Radio] = useState(1)
  const [list2Radio, setList2Radio] = useState(1)
  const selectedCountry = useCountryContextContext()

  const radioOption1 = ['Yes', 'No']
  const listOptions1 = ['Under 1000', 'Under 2000', 'Under 5000']
  const listOptions2 = ['Less than 1 month', '3 Months or more']

  //OnSubmit Function =>

  const updateCheckboxes = (msg) => {
    setCheckboxes((prevState) =>
      prevState.map((item) => (msg === item.msg ? { ...item, state: !item.state } : { ...item })),
    )
  }

  const successFlow = (values) => {
    //display success message to user.
    //send email to service owner
    //Disable send button

    // setButtonState(true)

    let interests = checkBoxes.filter((item) => item.state === true)
    interests = interests.map((item) => item.msg)

    let templateParams = {
      fullname: values.firstName + ' ' + values.lastName,
      company: values.companyName,
      email: values.email,
      contactNumber: values.contactNumber,
      comments: values.comments,
      interests: interests,
      outsourcingInteractionns: radioOption1[radioOption - 1],
      projectedContactVolume: listOptions1[list1Radio - 1],
      duration: listOptions2[list2Radio - 1],
      country: selectedCountry.country.value,
    }
    const successSend = true
    if (successSend) {
      setResMsg({ msg: 'Your request has been received.', eleClass: 'trans-success' })
    } else {
      setResMsg({ msg: 'Your request has been received.', eleClass: 'trans-success' })
      //Enable send button
      setButtonState(false)
    }

    // emailjs.send('service_ji3lq3e', 'template_p4cv6zn', templateParams, 'user_R7HCclwvKPy5qibmkBZh7').then(
    //   function (response) {
    //   },
    //   function (error) {
    //   },
    // )
  }

  return (
    <div className="paymentForm">
      <Formik
        initialValues={{
          companyName: '',
          firstName: '',
          lastName: '',
          email: '',
          contactNumber: '',
          comments: '',
        }}
        validationSchema={paypalValidation}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          // submitPayment(values)
          successFlow(values)
          setSubmitting(false)
          resetForm()
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          submitForm,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            <h1>Request A Quote</h1>
            <h4>We are happy to get you a favouable quatation that best suits your company/business.</h4>
            <div className="paymentForm__subtitle">Basic Info</div>
            <hr />

            <div className="paymentForm__formList">
              <div className="inputField">
                <input
                  type="text"
                  name="companyName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.companyName}
                  placeholder="Company Name (optional)"
                />
                <div className="error">{errors.companyName && touched.companyName && errors.companyName}</div>
              </div>
              <div className="inputField">
                <input
                  type="text"
                  name="firstName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.firstName}
                  placeholder="First Name"
                />
                <div className="error">{errors.firstName && touched.firstName && errors.firstName}</div>
              </div>
              <div className="inputField">
                <input
                  type="text"
                  name="lastName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.lastName}
                  placeholder="Last Name"
                />
                <div className="error">{errors.lastName && touched.lastName && errors.lastName}</div>
              </div>
              <div className="inputField">
                <input
                  type="email"
                  name="email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  placeholder="Email"
                />
                <div className="error">{errors.email && touched.email && errors.email}</div>
              </div>
              <div className="inputField">
                <input
                  type="text"
                  name="contactNumber"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.contactNumber}
                  placeholder="Contact Number"
                />
                <div className="error">
                  {errors.contactNumber && touched.contactNumber && errors.contactNumber}
                </div>
              </div>
            </div>
            <div className="customizeForm">
              <hr />

              <div className="interestedServices">
                <div className="title">Which service are you interested in?</div>
                <div className="checkboxList">
                  {checkBoxes.map((item) => (
                    <CheckboxComponent
                      state={item.state}
                      key={item.msg}
                      msg={item.msg}
                      onclick={updateCheckboxes}
                    />
                  ))}
                </div>

                <div className="interactionsQuestion">
                  Are you currently outsourcing your customer interactions?
                </div>
                <div className="outsourceRadio">
                  <div onClick={() => setRadioOption(1)} className="radioButton">
                    <img src={radioOption === 1 ? checkedIcon : uncheckedIcon} alt="" />
                    <div className="">Yes</div>
                  </div>
                  <div onClick={() => setRadioOption(2)} className="radioButton">
                    <img src={radioOption === 2 ? checkedIcon : uncheckedIcon} alt="" />
                    <div className="">No</div>
                  </div>
                </div>
                <div className="contactVolume">What is your monthly projected contact volumes?</div>
                <div className="projectContactSelect">
                  <div className="list1">
                    <div onClick={() => setList1Radio(1)} className="radioButton">
                      <img src={list1Radio === 1 ? checkedIcon : uncheckedIcon} alt="" />
                      <div className="">Under 1000</div>
                    </div>
                    <div onClick={() => setList1Radio(2)} className="radioButton">
                      <img src={list1Radio === 2 ? checkedIcon : uncheckedIcon} alt="" />
                      <div className="">Under 2000</div>
                    </div>
                    <div onClick={() => setList1Radio(3)} className="radioButton">
                      <img src={list1Radio === 3 ? checkedIcon : uncheckedIcon} alt="" />
                      <div className="">Under 5000</div>
                    </div>
                  </div>
                  <div className="contactVolume">Duration?</div>

                  <div className="list2">
                    <div onClick={() => setList2Radio(1)} className="radioButton">
                      <img src={list2Radio === 1 ? checkedIcon : uncheckedIcon} alt="" />
                      <div className="">Less than 1 month</div>
                    </div>
                    <div onClick={() => setList2Radio(2)} className="radioButton">
                      <img src={list2Radio === 2 ? checkedIcon : uncheckedIcon} alt="" />
                      <div className="">3 Months or more</div>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <textarea
                rows="5"
                placeholder="Additional comments"
                name="comments"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.comments}
              ></textarea>
            </div>

            <Button
              type="primary"
              text="Request a Quote"
              buttonType="submit"
              onclick={submitForm}
              isDisabled={buttonState}
            />
            <div className={`formSubmittedMessage ${resMsg.eleClass}`}>{resMsg.msg}</div>
            <p>By clicking "Submit Payment" you agree to our&nbsp;
              <a href="/terms-and-conditions" target="_blank">Terms of Service</a> and&nbsp;
              <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
            </p>
          </form>
        )}
      </Formik>
    </div>
  )
}

export default CustomizeForm
